import { useNavigate } from "react-router-dom";
function AddToCart(props) {
  const { product, salePrice } = props;
  const quantity = 1;
  const item = { ...product, quantity, salePrice };
  const navigate = useNavigate();

  const handleAddToCart = (event) => {
    event.preventDefault();
    event.stopPropagation();
    props.addToCart(item);
    navigate("/cart");
  };

  return (
    <button className="addtocart" onClick={handleAddToCart}>
      Add To Cart
    </button>
  );
}

export default AddToCart;
